/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {ListProjectsParams, ProjectDetailResponse, ProjectListCounts, ProjectListPage} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Lists one page of public projects, optionally filtered/sorted
 */
export type listProjectsResponse200 = {
  data: ProjectListPage
  status: 200
}

export type listProjectsResponseSuccess = listProjectsResponse200 & {
  headers: Headers
}
export type listProjectsResponse = listProjectsResponseSuccess

export const getListProjectsUrl = (params?: ListProjectsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/projects?${stringifiedParams}` : `/projects`
}

export const listProjects = async (
  params?: ListProjectsParams,
  options?: RequestInit,
): Promise<listProjectsResponse> => {
  return customFetch<listProjectsResponse>(getListProjectsUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * Readiness-aware public project counts per pricing tier (gallery tier chips)
 */
export type listProjectCountsResponse200 = {
  data: ProjectListCounts
  status: 200
}

export type listProjectCountsResponseSuccess = listProjectCountsResponse200 & {
  headers: Headers
}
export type listProjectCountsResponse = listProjectCountsResponseSuccess

export const getListProjectCountsUrl = () => {
  return `/projects/counts`
}

export const listProjectCounts = async (options?: RequestInit): Promise<listProjectCountsResponse> => {
  return customFetch<listProjectCountsResponse>(getListProjectCountsUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Lists distinct tags across all public projects (sorted)
 */
export type listProjectTagsResponse200 = {
  data: string[]
  status: 200
}

export type listProjectTagsResponseSuccess = listProjectTagsResponse200 & {
  headers: Headers
}
export type listProjectTagsResponse = listProjectTagsResponseSuccess

export const getListProjectTagsUrl = () => {
  return `/projects/tags`
}

export const listProjectTags = async (options?: RequestInit): Promise<listProjectTagsResponse> => {
  return customFetch<listProjectTagsResponse>(getListProjectTagsUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Lists distinct palette color IDs present in public scenes (canonical palette order)
 */
export type listProjectColorsResponse200 = {
  data: string[]
  status: 200
}

export type listProjectColorsResponseSuccess = listProjectColorsResponse200 & {
  headers: Headers
}
export type listProjectColorsResponse = listProjectColorsResponseSuccess

export const getListProjectColorsUrl = () => {
  return `/projects/colors`
}

export const listProjectColors = async (options?: RequestInit): Promise<listProjectColorsResponse> => {
  return customFetch<listProjectColorsResponse>(getListProjectColorsUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Returns a single public project by slug
 */
export type getProjectResponse200 = {
  data: ProjectDetailResponse
  status: 200
}

export type getProjectResponseSuccess = getProjectResponse200 & {
  headers: Headers
}
export type getProjectResponse = getProjectResponseSuccess

export const getGetProjectUrl = (slug: string) => {
  return `/projects/${slug}`
}

export const getProject = async (slug: string, options?: RequestInit): Promise<getProjectResponse> => {
  return customFetch<getProjectResponse>(getGetProjectUrl(slug), {
    ...options,
    method: 'GET',
  })
}
